import styled from 'styled-components';
import { darken } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Paper from '@material-ui/core/Paper';

export const StyledMessageWindowContainer = styled.div`
    ${({ theme }) => `
    border: 1px solid ${theme.palette.common.gray7};
    border-radius: 12px;    
    box-sizing: border-box;
    box-shadow: 1px 2px 12px 1px rgba(71, 77, 108, 0.04);
    background-color: ${theme.palette.common.white};

    position: relative;
    `}
`;

export const StyledMessageListWindow = styled.div`
    ${({ $width, $height }) => `
    width: ${$width ? $width : '369px'};
    height: ${$height ? $height : '100%'};
    overflow: hidden;

    display: grid;
    grid-template-rows: auto 1fr;
    
    padding: 15px 12px;

    `}
`;

export const StyledMessageHeader = styled.div`
    ${() => `
    margin-bottom: 10px;
    `}
`;

export const StyledMessageList = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    overflow-Y: auto;
    `}
`;

export const StyledMessage = styled.div`
    ${({ theme, isRead }) => `
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding: 10px;

    background-color: ${isRead ? 'transparent' : theme.palette.common.gray13};
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background-color: ${darken(theme.palette.common.gray13, 0.1)};
    }
    `}
`;

export const StyledAvatarContainer = styled.div`
    ${() => `
    position: relative;
    `}
`;

export const StyledBadge = styled.div`
    ${({ theme }) => `
    position: absolute;
    top: 0;
    right: 0;

    width: 11px;
    height: 11px;

    background-color: ${theme.palette.common.blue7};
    border: 1px solid ${theme.palette.common.white};
    border-radius: 50%;
    z-index: 1;
    `}
`;

export const StyledMessageContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 5px;
    `}
`;

export const StyledTimeContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    `}
`;

export const StyledChatContainer = styled.div`
    ${({ fullScreen }) => `
    box-sizing: border-box;
    position: fixed;
    right: 0;
    bottom:0;     
    height: 50px;
    width: auto;

    display: flex;
    justify-content: flex-end;
    padding: 0 20px;

    z-index: 1100;

    ${
        fullScreen
            ? `
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
    `
            : ''
    }

    `}
`;

export const StyledChatWindow = styled.div`
    ${({ theme, fullScreen, collapsed }) => `

    position: absolute;
    right: 30px;
    bottom: 0;

    width: 369px;
    height: 463px;

    display: grid;
    grid-template-rows: auto 1fr auto;

    background-color: ${theme.palette.common.white};
    border: 1px solid ${theme.palette.common.gray7};
    box-sizing: border-box;
    box-shadow: 1px 2px 12px 1px rgba(71, 77, 108, 0.04);
    border-radius: 12px;    

    ${
        fullScreen
            ? `
        right: 0;
        height: 100%;
        width: 100%;
        border: none;
        border-radius: 0;
    `
            : ''
    }

    ${
        collapsed
            ? `
    height: auto;
    border-radius: 12px 12px 0 0;
    `
            : ''
    }

`}
`;
export const StyledMesageHeader = styled.div`
    ${({ theme, collapsed }) => `
    display: flex;
    align-items: center;
    column-gap: 10px;

    padding: 10px 15px;

    border-bottom: 1px solid ${theme.palette.common.gray7};

    ${collapsed ? `border-bottom: none;` : ''}

`}
`;

export const StyledTextGroup = styled.div`
    ${() => `
    display: flex;
    flex-direction: column-reverse;
    overflow-Y: auto;

    row-gap: 10px;
    `}
`;

export const StyledTextContainer = styled.div`
    ${() => `
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column-reverse;
    padding: 0 15px;
    position: relative;

    row-gap: 10px;
    `}
`;

export const StyledChatInputContainer = styled.div`
    ${() => `
    display: grid;
    align-items: center;
    grid-template-columns: 1fr auto;
    column-gap: 10px;

    padding: 15px 15px 5px 15px;

    `}
`;

export const StyledNameContainer = styled.div`
    ${() => `
    align-self: flex-start;
    `}
`;

export const StyledCloudContainer = styled.div`
    ${() => `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 5px;
    `}
`;

export const StyledTextCloudContainer = styled.div`
    ${({ isMy }) => `
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: ${isMy ? 'flex-end' : 'flex-start'};
    column-gap: 5px;
    `}
`;

export const StyledTextCloud = styled.div`
    ${({ theme, isMy }) => `
    max-width: 75%;
 
    padding: 7px 10px;
    border-radius: 12px;
    background-color: ${isMy ? theme.palette.common.black : theme.palette.common.gray8};
    `}
`;

export const StyledTextErrorContainer = styled.div`
    ${({ isMy }) => `
    width: 100%;
    display: flex;
    justify-content: ${isMy ? 'flex-end' : 'flex-start'};
    column-gap: 10px;
    `}
`;

export const StyledMessageFooter = styled(ButtonBase)`
    ${({ theme }) => `
    height: 50px;

    border-top: 1px solid ${theme.palette.common.gray7};
    border-radius: 0 0 11px 11px;

    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    `}
`;

export const StyledPaper = styled(Paper)`
    ${() => `
    background-color: rgba(0, 0, 0, 0);
    box-shadow: none;
    `}
`;
